import DefaultUpdater from "../../../common/DefaultUpdater";

export default function OtherVehicleInformation({classes, data, type, folder}) {
    return <>
        <div className={classes.sidebar_row_block}>
            <h3>Vehicle Information</h3>
        </div>

        <div className={classes.sidebar_row_block}>
            <DefaultUpdater type={'input'} value={data.vehicle_make} label={'Vehicle Make'} identifier={{type: type, field: 'vehicle_make', type_id: data.id, folder: folder}} />
        </div>

        <div className={`${classes.sidebar_row} ${classes.sidebar_row_group}`}>
            <div className={classes.group_flex_2}>
                <DefaultUpdater type={'input'} value={data.vehicle_model} label={'Vehicle Model'} identifier={{type: type, field: 'vehicle_model', type_id: data.id, folder: folder}} />
            </div>
            <div className={classes.group_flex_1}>
                <DefaultUpdater type={'input'} value={data.vehicle_year} label={'Vehicle Year'} identifier={{type: type, field: 'vehicle_year', type_id: data.id, folder: folder}} />
            </div>
            
        </div>
        <div className={classes.sidebar_row_block}>
            <DefaultUpdater type={'textarea'} value={data.vehicle_damage} label={'Vehicle Damage'} identifier={{type: type, field: 'vehicle_damage', type_id: data.id, folder: folder}} />
        </div>
    </>
}